import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, Settings } from 'lucide-react';
import { useCookie } from '../../contexts/CookieContext';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

export function CookieBanner() {
  const { showBanner, acceptAll, rejectAll, openSettings } = useCookie();

  if (!showBanner) {
    return null;
  }

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          className="fixed bottom-0 left-0 right-0 z-[99] p-4 md:p-6"
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '100%', opacity: 0 }}
          transition={{ 
            type: 'spring', 
            damping: 30, 
            stiffness: 300,
            duration: 0.4 
          }}
        >
          <div className="container-max">
            <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-6 md:p-8 max-w-6xl mx-auto">
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                {/* 左侧内容 */}
                <div className="flex-1 space-y-4">
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-zwheel-black rounded-lg">
                      <Cookie className="h-6 w-6 text-white" />
                    </div>
                    <h3 className="text-lg md:text-xl font-bold text-zwheel-black">
                      Uso de Cookies
                    </h3>
                  </div>
                  
                  <div className="space-y-2">
                    <p className="text-sm md:text-base text-zwheel-gray-600 leading-relaxed">
                      Utilizamos cookies para mejorar su experiencia de navegación, analizar el tráfico del sitio 
                      y personalizar el contenido. Al hacer clic en "Aceptar todas", usted acepta nuestro uso de cookies.
                    </p>
                    <p className="text-xs text-zwheel-gray-500">
                      Puede gestionar sus preferencias de cookies en cualquier momento haciendo clic en "Configuración".
                    </p>
                  </div>

                  <a
                    href="/legal/cookies"
                    className="inline-block text-sm text-blue-600 hover:text-blue-700 underline"
                  >
                    Leer nuestra Política de Cookies
                  </a>
                </div>

                {/* 右侧按钮 */}
                <div className="flex flex-col sm:flex-row md:flex-col gap-3 md:gap-2 flex-shrink-0 md:w-auto sm:w-full">
                  <Button
                    onClick={acceptAll}
                    className={cn(
                      'bg-zwheel-black hover:bg-zwheel-gray-800 text-white',
                      'w-full sm:w-auto md:w-full px-6 py-2.5',
                      'font-medium transition-colors'
                    )}
                  >
                    Aceptar Todas
                  </Button>
                  
                  <Button
                    onClick={rejectAll}
                    variant="outline"
                    className={cn(
                      'border-zwheel-gray-300 text-zwheel-gray-700 hover:bg-zwheel-gray-50',
                      'w-full sm:w-auto md:w-full px-6 py-2.5',
                      'font-medium transition-colors'
                    )}
                  >
                    Rechazar Todas
                  </Button>
                  
                  <Button
                    onClick={openSettings}
                    variant="outline"
                    className={cn(
                      'border-zwheel-gray-300 text-zwheel-gray-700 hover:bg-zwheel-gray-50',
                      'w-full sm:w-auto md:w-full px-6 py-2.5',
                      'font-medium transition-colors',
                      'flex items-center justify-center space-x-2'
                    )}
                  >
                    <Settings className="h-4 w-4" />
                    <span>Configuración</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

